/**
 * Pads a customer number with leading zeros to ensure it is always 10 digits.
 *
 * Examples:
 *   '12345'      → '0000012345'
 *   '0000012345' → '0000012345'
 *   '123'        → '0000000123'
 */
export function padCustomerNumber(customerNumber: string): string {
  const trimmed = customerNumber.trim();
  if (!trimmed) return trimmed;
  return trimmed.padStart(10, '0');
}
